import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import Ranking from "./components/Ranking";
import Category from "./components/Category";
import Latest from "./components/Latest";
import Featured from "./components/Featured";
import Feedback from "./components/Feedback";
import Faq from "./components/Faq";
import Subscribe from "./components/Subscribe";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "奇妙漫画是免费观看的吗？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "是的，奇妙漫画的核心内容全部免费观看，无需付费即可畅读全部连载。",
      },
    },
    {
      "@type": "Question",
      name: "多久更新一次？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "平台内热门作品保持每日更新，绝大多数连载漫画每周都有多话更新。",
      },
    },
    {
      "@type": "Question",
      name: "有哪些题材分类？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "奇妙漫画涵盖异世界、魔法、脑洞、冒险、悬疑、热血等丰富题材。",
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Navbar />
      <main>
        <Hero />
        <Ranking />
        <Category />
        <Latest />
        <Featured />
        <Feedback />
        <Faq />
        <Subscribe />
      </main>
      <Footer />
    </>
  );
}